exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".vector-view{position:absolute;top:0;left:0;pointer-events:none}.vector-view,.vector-view svg{width:100%;height:100%}", "", {"version":3,"sources":["/Users/jeor/Downloads/03OCW/applets/fieldplay-main-FIRST/src/components/VectorView.vue"],"names":[],"mappings":"AACA,aACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AAGR,mBAAqB,CACtB,AACD,8BAJE,WAAY,AACZ,WAAa,CAMd","file":"VectorView.vue","sourcesContent":["\n.vector-view {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n.vector-view svg {\n  width: 100%;\n  height: 100%;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ea57251a","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/VectorView.vue
// module id = kXcB
// module chunks = 0